<template>
  <div>
    <div class="title-text pt-4 mb-4 d-none d-lg-block">Service Directory</div>
    <button
      class="hamburger-button navbar-toggler pb-md-2 pb-4 pt-2 toggle-sl-button d-block d-sm-block d-lg-none ml-md-0"
      type="button"
      data-toggle="collapse"
      data-target="#navbarNav"
      aria-controls="navbarNav"
      aria-expanded="false"
      aria-label="Toggle navigation"
      ref="navbarToggler"
    >
      <img src="../../assets/image/hamburger_menu_icon.svg" alt="hamburger-dropdown">
    </button>
    <nav
      class="navbar navbar-expand-lg navbar-light pl-0 sl-navbar justify-content-lg-start justify-content-center all-platform-categories-container"
    >
      <div class="w-100">
        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="nav nav-tabs d-block w-100 border-0">
            <li v-for="(category, index) in filteredPlatformCategories" :key="category.id">
              <div class="row mx-0">
                <div
                  v-if="category && category.name"
                  class="categories-options"
                  :class="category.isSelected ? 'solution-link' : null"
                  @click="handleClickServiceDirectory(category.alias)"
                >{{directoryName(category.name)}}</div>
              </div>
              <hr>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import * as CONSTANTS from "@/store/constants";
import filter from "@/utils/filter";
export default {
  name: "service-directory-categories",
  props: ["selectedDirectory"],
  computed: {
    ...mapGetters(["serviceDirectoryCategories"]),
    filteredPlatformCategories() {
      let filteredCategories = this.serviceDirectoryCategories;
      filteredCategories.sort((a, b) => (a.name > b.name ? 1 : -1));
      let checkAllDirectory = filteredCategories.filter(
        category => category["alias"] === CONSTANTS.ALL_SERVICE_DIRECTORY
      );
      if (checkAllDirectory === undefined || checkAllDirectory.length == 0) {
        let category = { name: "All", alias: CONSTANTS.ALL_SERVICE_DIRECTORY };
        filteredCategories.push(category);
      }
      filteredCategories.forEach(category => {
        category.alias === this.selectedDirectory
          ? (category.isSelected = true)
          : (category.isSelected = false);
      });
      filteredCategories.sort(function(x, y) {
        return x.alias == CONSTANTS.ALL_SERVICE_DIRECTORY
          ? -1
          : y.alias == CONSTANTS.ALL_SERVICE_DIRECTORY
          ? 1
          : 0;
      });
      return filteredCategories;
    }
  },
  methods: {
    ...mapMutations(["setLoadingServiceDirectories"]),
    handleClickServiceDirectory(directory) {
      let navbar = document.getElementById("navbarNav");
      navbar.classList.remove("show");
      if (this.selectedDirectory !== directory) {
        this.setLoadingServiceDirectories(true);
        this.$emit("handleClickServiceDirectory", directory);
      }
    },
    directoryName(directory) {
      return directory == directory.toUpperCase() &&
        directory != CONSTANTS.IT_PLATFORM
        ? filter.pascalCase(directory)
        : directory;
    }
  }
};
</script>

<style scoped>
.categories-options {
  cursor: pointer;
}
.categories-options:hover {
  color: var(--secondary-color-hover);
  white-space: nowrap;
  font-weight: bold;
}
.title-text {
  font-size: 20px !important;
  margin-top: 35px;
  white-space: nowrap;
  font-weight: bold;
  font-family: artifaktElementBold !important;
}
.solution-link {
  color: var(--secondary-color);
  cursor: pointer;
  font-size: 16px;
  white-space: nowrap;
  font-weight: bold;
}
.hamburger-button {
  padding-left: 0 !important;
}
.navbar-toggler:focus,
.navbar-toggler:active,
.navbar-toggler-icon:focus {
  outline: none;
  box-shadow: none;
}
hr {
  margin-top: 0.85rem;
  margin-bottom: 0.85rem;
}
.all-platform-categories-container {
  color: #000000 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/enterprise-service-directory/ServiceDirectoryCategories.vue